import { useEffect, useState } from 'react';

/**
 * Lightweight count-up animation for industrial-style stats.
 * Uses requestAnimationFrame, no external dep.
 * Reruns if `value` changes. Safe under React StrictMode (cleanup cancels raf).
 */
export const StatCounter = ({ value, duration = 1200, decimals = 0, className = '', prefix = '', suffix = '' }) => {
  const target = Number(value) || 0;
  const [display, setDisplay] = useState(target);

  useEffect(() => {
    const start = performance.now();
    let raf;
    setDisplay(0);
    const step = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      setDisplay(target * eased);
      if (p < 1) raf = requestAnimationFrame(step);
      else setDisplay(target);
    };
    raf = requestAnimationFrame(step);
    return () => {
      if (raf) cancelAnimationFrame(raf);
    };
  }, [target, duration]);

  const formatted = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(display);

  return (
    <span className={`font-mono tabular-nums ${className}`}>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
};
